export enum SoundItem {
  Background = 'background',
  Click = 'click',
  Quarter = 'quarter',
  Lost = 'lost',
  Win = 'win',
}
